import { Injectable } from "@angular/core";

@Injectable()
export class AppService {
  fileReaded: any;

  downloadFile(data, filename = "data", headers) {
    let csvData = this.ConvertToCSV(data, headers);
   // console.log(csvData);
    let blob = new Blob(["\ufeff" + csvData], {
      type: "text/csv;charset=utf-8;",
    });
    let dwldLink = document.createElement("a");
    let url = URL.createObjectURL(blob);
    let isSafariBrowser =
      navigator.userAgent.indexOf("Safari") != -1 &&
      navigator.userAgent.indexOf("Chrome") == -1;
    if (isSafariBrowser) {
      //if Safari open in new window to save file with random filename.
      dwldLink.setAttribute("target", "_blank");
    }
    dwldLink.setAttribute("href", url);
    dwldLink.setAttribute("download", filename + ".csv");
    dwldLink.style.visibility = "hidden";
    document.body.appendChild(dwldLink);
    dwldLink.click();
    document.body.removeChild(dwldLink);
  }

  ConvertToCSV(objArray, headerList) {
    let array = typeof objArray != "object" ? JSON.parse(objArray) : objArray;
    let str = "";
    let row = "S.No,";

    for (let index in headerList) {
      row += headerList[index] + ",";
    }
    row = row.slice(0, -1);
    str += row + "\r\n";
    for (let i = 0; i < array.length; i++) {
      let line = i + 1 + "";
      for (let index in headerList) {
        let head = headerList[index];

        line += "," + array[i][head];
      }
      str += line.replace(/ +/g, " ") + "\r\n";
    }
    return str;
  }

  convertFile(csv: any) {
    return new Promise((resolve, reject) => {
      this.fileReaded = csv.target.files[0];

      let reader: FileReader = new FileReader();
      reader.readAsText(this.fileReaded);

      reader.onload = (e) => {
        let csv: any = reader.result;
        let allTextLines = csv.split(/\r|\n|\r/);
       // console.log(allTextLines);
        let headers = allTextLines[0].split(",");
        let lines = [];

        for (let i = 0; i < allTextLines.length; i++) {
          // split content based on comma
          let data = allTextLines[i].split(",");
          if (data.length === headers.length) {
            let tarr = [];
            for (let j = 0; j < headers.length; j++) {
              tarr.push(data[j]);
            }

            // log each row to see output
            // console.log(tarr);
            lines.push(tarr);
          }
        }
        // all rows in the csv file
        //  console.log(">>>>>>>>>>>>>>>>>", lines);
        resolve(lines);
      };
    });
  }
}
